import ApplicationListPage from '@/modules/account/pages/ApplicationListPage'
import ApplicationFormPage from '@/modules/account/pages/ApplicationFormPage'
import ApplicationChannelsPage from '@/modules/account/pages/ApplicationChannelsPage'
import ApplicationSDKIntegrationPage from '@/modules/account/pages/ApplicationSDKIntegrationPage'
import ApplicationPushPage from '@/modules/account/pages/ApplicationPushPage'
import ApplicationInboxPage from '@/modules/account/pages/ApplicationInboxPage'
import ApplicationInappPage from '@/modules/account/pages/ApplicationInappPage'

export default [
  {
    name: 'Applications',
    path: '/account/application/index',
    component: ApplicationListPage,
    meta: {
      title: 'ApplicationList_Title'
    }
  },
  {
    name: 'ApplicationCreate',
    path: '/account/application/create',
    component: ApplicationFormPage,
    meta: {
      title: 'ApplicationForm_CreateTitle',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ApplicationChannels',
    path: '/account/application/channels',
    component: ApplicationChannelsPage,
    meta: {
      title: 'ApplicationsChannels_Title',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ApplicationPush',
    path: '/account/application/push',
    component: ApplicationPushPage,
    meta: {
      title: 'ApplicationsChannels_Title',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ApplicationInbox',
    path: '/account/application/inbox',
    component: ApplicationInboxPage,
    meta: {
      title: 'ApplicationInbox_Title',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ApplicationInapp',
    path: '/account/application/inapp',
    component: ApplicationInappPage,
    meta: {
      title: 'ApplicationInapp_Title',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ApplicationUpdate',
    path: '/account/application/update',
    component: ApplicationFormPage,
    meta: {
      title: 'ApplicationForm_UpdateTitle',
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'ApplicationView',
    path: '/account/application/view',
    component: ApplicationFormPage,
    props: { readonly: true },
    meta: {
      title: 'ApplicationForm_ViewTitle'
    }
  },
  {
    name: 'ApplicationSDKIntegration',
    path: '/account/application/sdk-integration',
    component: ApplicationSDKIntegrationPage,
    meta: {
      title: 'ApplicationSDKIntegration_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/account/router/index.js